<template>
  <div class="authentication action-setup">
      <section class="section">
          <div class="container">
              <h4 class="title page-title has-text-centered has-padding-v-50 is-4" v-if="editing === false">Action setup page</h4>
              <h4 class="title page-title has-text-centered has-padding-v-50 is-4" v-if="editing === true">Action edit page</h4>
              <b-message v-if="editing === false">
                  <h5 class="is-uppercase has-margin-v-10 has-text-weight-semibold">Action setup info</h5>

                  <div v-if="!showAllHelp" class="content has-margin-v-10">
                    Now you can configure the connections you want to make with BestAgent, either send information to BestAgent, receive information from BestAgent or both.</br>
                    </br>
                    You need to configure a connection for each type of data and you event you want to work with. For example, if you need to send property data, you can create one connection to send a property every time a new property is added on your system, and another when a property on your system is updated.</br>
                  </div>
                  <a class="button is-rounded" @click.prevent="showAllHelp = !showAllHelp">
                      <span class="icon">
                          <i class="fas" :class="showAllHelp ? ' fa-chevron-up' : ' fa-chevron-down'"></i>
                      </span>
                      <span>{{ showAllHelp ? 'Hide all steps' : 'View all steps' }}</span>
                  </a>
                  <div v-if="showAllHelp" class="content has-margin-v-10">
                      <p>Now you can configure the connections you want to make with BestAgent, either send information to BestAgent, receive information from BestAgent or both.</br>
</br>
You need to configure a connection for each type of data and you event you want to work with. For example, if you need to send property data, you can create one connection to send a property every time a new property is added on your system, and another when a property on your system is updated.</br>
</br>
The first step is to choose if you need to send data to BestAgent (Send to BA) or if you need to receive data from BestAgent (Receive from BA).</br>
</br>
If you choose to send data to BestAgent, you need to select the type of action you want BestAgent to execute with your data. It could be adding an applicant on BestAgent, update a property or send a new property owner, for example.</br>
</br>
As soon as you choose the type of action, you need to click the “Generate Webhook URL” button which will generate a unique webhook url for your connection. Every time you have new data to send to BestAgent, you just need to send your data to this unique webhook.
This data, at this stage, needs to have a specific format that is listed on the Payload section.
The final step for adding a “Send to BA” connection is to click Test & Save and then you have to send a sample of data to this webhook URL, so that the connection is validated.</br>
</br>
If you choose to receive data from BestAgent (Receive from BA), you need to select the event you want to be notified about when it happens in your client’s BestAgent account, like a new property being added on BestAgent, or an applicant updated, etc. Then you need to provide us with the URL on your system where we can send the data every time the event you selected happens on BestAgent/brbr>
</br>
As soon as you click Test & Save, BestAgent will send a sample of the data of the event you selected to the provided URL, so you can confirm you received correctly the data.</p>
                  </div>
              </b-message>

              <div v-if="action.actionId" style="margin-bottom:25px;">
                  <h4 class="title is-4">Action ID:</h4>
                  <div class="control">
                      <input class="input" type="text" :value="action.actionId"  readonly>
                  </div>
              </div>

              <!-- MODE -->
              <div class="action-setup__mode">
                  <h4 class="title is-4">Mode</h4>
                  <p class="subtitle is-6">Choose if you want to send information to BestAgent or receive information from BestAgent</p>
                  <div class="field has-addons">
                      <p class="control">
                          <a class="button" :class="{'is-selected': mode == MODES.SEND}" @click="mode = MODES.SEND; action.type = mode;">
                              <span class="icon is-small">
                                <i class="fas fa-arrow-up"></i>
                              </span>
                              <span>Send to BA</span>
                          </a>
                      </p>
                      <p class="control">
                          <a class="button" :class="{'is-selected': mode == MODES.RECEIVE}" @click="mode = MODES.RECEIVE; action.type = mode;">
                              <span class="icon is-small">
                                <i class="fas fa-arrow-down"></i>
                              </span>
                              <span>Receive from BA</span>
                          </a>
                      </p>
                  </div>
              </div>

              <!-- SEND ACTION -->
              <div v-if="mode == MODES.SEND" class="action-setup__action">
                  <h4 class="title is-4">Action</h4>
                  <p class="subtitle is-6">Choose The action you want to execute on BestAgent with your data</p>
                  <div class="select is-rounded">
                      <select v-model="action.action">
                          <option value="">-- Type</option>
                          <option v-for="type in typesList" :value="type.id" :key="type.id" :disabled="type.disabled" v-bind:class="type.disabled ? 'disabled' : ''">{{type.label}}</option>
                      </select>
                  </div>
                  <div class="select-space-mobile"> </div>
                  <div class="select is-rounded">
                      <select v-model="action.method" v-on:change="methodPicked">
                          <option value="">-- Method</option>
                          <option v-for="method in methodsList" :value="method.id" :key="method.id" :disabled="method.disabled">{{method.label}}</option>
                      </select>
                  </div>

                  <!-- WEBHOOK URL -->
                  <div v-if="action.action && action.method" class="action-setup__webhook">
                      <h4 class="title is-4">Webhook URL</h4>
                      <p class="subtitle is-6">Use this webhook to send data for this action on BestAgent</p>
                      <div class="field has-addons">
                        <p class="control">
                            <a class="button is-dark" @click.prevent="generateWebhook">
                              {{ webhook ? 'Regenerate Webhook URL' : 'Generate Webhook URL' }}
                            </a>
                        </p>
                          <p class="control is-expanded">
                              <input class="input" type="text" :value="webhook" readonly>
                          </p>
                      </div>
                      <p class="help">This is your unique webhook URL.</p>
                  </div>
              </div>

              <!-- RECEIVE  -->
              <div v-if="mode == MODES.RECEIVE">
                  <!-- EVENT -->
                  <div class="action-setup__event">
                      <h4 class="title is-4">Event</h4>
                      <p class="subtitle is-6">Choose the Event you want to get from BestAgent with our data</p>
                      <div class="select is-rounded">
                          <select v-model="action.action">
                              <option value="">-- Type</option>
                              <option v-for="type in typesList" :value="type.id" :disabled="type.disabled" v-bind:class="type.disabled ? 'disabled' : ''">{{type.label}}</option>
                          </select>
                      </div>
                      <div class="select-space-mobile"> </div>
                      <div class="select is-rounded">
                          <select v-model="action.method" v-on:change="methodPicked">
                              <option value="">-- Method</option>
                              <option v-for="method in methodsList" :value="method.id" :key="method.id">{{method.label}}</option>
                          </select>
                      </div>
		                  <div class="is-rounded" style="margin-left:15px;display: inline-block;max-width: 100%;position: relative;vertical-align: top;" v-if="ACTIONS[action.action] && ACTIONS[action.action].CONDITIONS && ACTIONS[action.action].CONDITIONS[action.method]">
		                    <b>Condition:</b>
		                    <p>
		                      <div v-for="cond in Object.keys(ACTIONS[action.action].CONDITIONS[action.method])" v-if="cond && conds[cond]">
														<div v-if="ACTIONS[action.action].CONDITIONS[action.method][cond] == 'single'">
															<span class="action-setup__schema__property-type tag is-outlined">{{ cond.toUpperCase() }}: </span>
															<span class="action-setup__schema__property-type tag is-outlined">{{ conds[cond].type }}</span>
															<div class="select is-rounded">
						                      <select v-model="conds[cond].value">
						                          <option value=""></option>
						                          <option v-for="val in conds[cond].values" :value="val" :key="val" disabled>{{val}}</option>
						                      </select>
						                  </div>
														</div>
														<div v-if="ACTIONS[action.action].CONDITIONS[action.method][cond] == 'fromto'">
															<span class="action-setup__schema__property-type tag is-outlined">{{ cond.toUpperCase() }}: </span>
															<div class="select is-rounded">
						                      <select v-model="conds[cond].from">
						                          <option value=""></option>
						                          <option v-for="val in conds[cond].values" :value="val" :key="val" disabled>{{val}}</option>
						                      </select>
						                  </div>
															<span class="action-setup__schema__property-type tag is-outlined"> to </span>
															<div class="select is-rounded">
						                      <select v-model="conds[cond].to">
						                          <option value=""></option>
						                          <option v-for="val in conds[cond].values" :value="val" :key="val" disabled>{{val}}</option>
						                      </select>
						                  </div>
														</div>
		                      </div>
		                    </p>
		                  </div>
                  </div>

                  <!-- WEBHOOK URL -->
                  <div v-if="action.action && action.method" class="action-setup__url">
                      <h4 class="title is-4">URL</h4>
                      <p class="subtitle is-6">Insert here your URL where you want to receive data.</p>
                      <div class="field has-addons">
                          <p class="control">
                              <span class="select">
                                  <select class="button is-light" v-model="action.requestMethod">
                                      <option value="GET">GET</option>
                                      <option value="POST">POST</option>
                                      <option value="PUT">PUT</option>
                                      <option value="PATCH">PATCH</option>
                                      <option value="DELETE">DELETE</option>
                                      <option value="HEAD">HEAD</option>
                                  </select>
                              </span>
                          </p>
                          <p class="control is-expanded">
                              <input v-model="action.requestUrl" class="input" type="text" placeholder="Url">
                          </p>
                      </div>
                  </div>
              </div>

							<!-- PAYLOAD -->
							<div class="action-setup__payload-wrapper" v-if="mode == MODES.RECEIVE || mode == MODES.SEND">
									<h4 class="title is-4">Payload</h4>
									<div class="columns">

											<div class="column action-setup__payload">
													<b-tooltip class="action-setup__payload__copy-btn" label="Copied!"
															:active="isCopied"
															type="is-dark"
															position="is-left"
															animated
															always>
															<button class="button is-small copy-btn" @click="copyText()">
																Copy
															</button>
													</b-tooltip>
													<pre v-highlightjs="sourcecode"><code class="javascript" id="payload"></code></pre>
											</div>

											<div class="column action-setup__schema">
													<h4 class="title is-4">Fields</h4>
													<table class="table is-size-7 is-narrow">
														<thead>
															<tr>
																<th>ID</th>
																<th>Type</th>
																<th>Required</th>
																<th>Description</th>
															</tr>
														</thead>
															<tbody>
																	<tr v-for="(item, name) in sourcecodeSchema">
																			<td class="action-setup__schema__property is-narrow has-text-right">
																					<span class="action-setup__schema__property-name">{{ name }}</span>
																			</td>
																			<td class="action-setup__schema__property is-narrow has-text-right">
																					<span class="action-setup__schema__property-type tag is-outlined">{{ item[2] }} </span>
																			</td>
																			<td class="action-setup__schema__property is-narrow has-text-right">
																					<span class="action-setup__schema__property-optional tag is-outlined" v-if="item[1] && item[1] != ''">{{ (item[1] && item[1] != '') ? 'Yes' : '' }}</span>
																			</td>
																			<td class="action-setup__schema__description">
																				{{ item[0] }}
																			</td>
																	</tr>
															</tbody>
													</table>
											</div>
									</div>
							</div>

              <!-- Save & Test -->
              <div class="action-setup__buttons">
                  <div class="action-setup__button"><a class="button btn-next is-marginless" id="btnsubmit" @click.prevent="save">Test & Save</a></div>
                  <div class="action-setup__button" v-if="editing === true"><a class="button is-outlined is-rounded btn-delete" id="btndel" @click="del()"><span>Remove</span><span class="icon is-small"><i class="fas fa-times"></i></span></a></div>
                  <div class="action-setup__button"><a class="button is-text btn-cancel" id="btncancel" @click="$router.push('/')">Cancel</a></div>
              </div>

          </div>
      </section>

      <b-loading :is-full-page="true" :active="isLoading"></b-loading>
  </div>
</template>

<script>
import api from '../libs/api';

export default {
  name: 'action',
  data() {
    return {
      sourcecode: '',
      sourcecodeSchema: '',
      MODES: {
        SEND: 1,
        RECEIVE: 2
      },
      ACTIONS: {
        APPOINTMENT: {
          LABEL: 'Appointment',
          METHODS: {
            NEWVIEWING: ['New Viewing', 'New Viewing', {
              "trackId": "Your-ID",
              "applicantId": "Your-ID",
              "agentId": "Your_Agent_ID",
              "propertyId": "Your-Property-ID",
              "ownerId": "Your-ID",
              "scheduledDate": "Mon Aug 05 2019 10:00"
            },{
              "trackId": ['Unique ID of the Appointment process', true, 'string'],
              "applicantId": ['Applicant ID', true, 'string'],
              "agentId": ['Agent ID', true, 'string'],
              "propertyId": ['Property ID', true, 'string'],
              "ownerId": ['Owner ID', false, 'string'],
              "scheduledDate": ['Date/Time of the Appointment', true, 'string'],
            },"BOOKING-VIEW-GENERATE"],
            NEWAPPRAISAL: ['New Appraisal', 'New Appraisal', {
              "trackId": "Your-ID",
              "agentId": "Your_Agent_ID",
              "propertyId": "Your-Property-ID",
              "ownerId": "Your-ID",
              "scheduledDate": "Mon Aug 05 2019 10:00"
            },{
              "trackId": ['Unique ID of the Appointment process', true, 'string'],
              "agentId": ['Agent ID', true, 'string'],
              "propertyId": ['Property ID', true, 'string'],
              "ownerId": ['Owner ID', true, 'string'],
              "scheduledDate": ['Date/Time of the Appointment', true, 'string'],
            },"BOOKING-APPRAISAL-GENERATE",true],
          }
        },
        OFFER: {
          LABEL: 'Offer',
          DISABLED: true
        },
        OWNER: {
					LABEL: 'Property Owners',
          METHODS: {
            ADD: ['Add Owner', 'Owner Added', {
              "ownerId": "Your-ID",
              "agentId": "Your_Agent_ID",
              "email": "userhas@email.com",
              "fullName": "Mr John Doe",
							"address":
							 { town: 'Hayes',
								 flatNumber: '1',
								 street: 'Bath Road',
								 postcode: 'UB3 5BP',
								 county: 'Greater London',
								 buildingNumber: 'A4',
								 latitude: 51.4815121,
								 longitude: -0.4365430999999944 },
              "mobile": "+44 7700 900694"
            },{
              "ownerId": ['Owner ID', true, 'string'],
              "agentId": ['Agent ID', true, 'string'],
              "email": ['Owner email', true, 'string'],
              "fullName": ['Owner full name', '', 'string'],
							"address": ['Owner address.', true, 'object',null,{ town: 'string',
								flatNumber: 'string',
								street: 'string',
								postcode: 'string',
								county: 'string',
								buildingNumber: 'string',
								latitude: 'number',
								longitude: 'number' }],
              "mobile": ['Owner mobile', '', 'string'],
            },'OWNER-ADDED'],
            EDIT: ['Edit Owner', 'Owner Edited',{
              "ownerId": "Your-ID",
              "agentId": "Your_Agent_ID",
              "email": "userhas@email.com",
              "fullName": "Mr John Doe",
							"address":
							 { town: 'Hayes',
								 flatNumber: '1',
								 street: 'Bath Road',
								 postcode: 'UB3 5BP',
								 county: 'Greater London',
								 buildingNumber: 'A4',
								 latitude: 51.4815121,
								 longitude: -0.4365430999999944 },
              "mobile": "+44 7700 900694"
            },{
							"ownerId": ['Owner ID', true, 'string'],
              "agentId": ['Agent ID', true, 'string'],
              "email": ['Owner email', true, 'string'],
              "fullName": ['Owner full name', '', 'string'],
							"address": ['Owner address.', true, 'object',null,{ town: 'string',
								flatNumber: 'string',
								street: 'string',
								postcode: 'string',
								county: 'string',
								buildingNumber: 'string',
								latitude: 'number',
								longitude: 'number' }],
              "mobile": ['Owner mobile', '', 'string'],
            },'OWNER-UPDATED'],
            DELETE: ['Delete Owner', 'Owner Deleted',{
              "ownerId": "Your-ID",
              "agentId": "Your_Agent_ID"
            },{
              "ownerId": ['Owner ID', '', 'string'],
              "agentId": ['Agent ID', '', 'string']
            },'OWNER-DELETED']
          }
        },
        APPLICANT: {
          LABEL: 'Applicant',
          METHODS: {
            ADD: ['Add Applicant', 'Applicant Added', {
              "applicantId": "Your-ID",
              "agentId": "Your_Agent_ID",
              "email": "userhas@email.com",
              "fullName": "Mr John Doe",
              "channel": "S",
              "mobile": "+44 7700 900694",
							"address":
							 { town: 'Hayes',
								 flatNumber: '1',
								 street: 'Bath Road',
								 postcode: 'UB3 5BP',
								 county: 'Greater London',
								 buildingNumber: 'A4',
								 latitude: 51.4815121,
								 longitude: -0.4365430999999944 },
							"type": "flat",
              "budget": 100000,
              "bedrooms": 2,
              "bathrooms": 2,
              "livingrooms": 1,
              "source": "zoopla",
            },{
              "applicantId": ['Applicant ID', true, 'string'],
              "agentId": ['Agent ID', true, 'string'],
              "email": ['Applicant email', true, 'string'],
              "fullName": ['Applicant full name', '', 'string'],
              "channel": ['Looking for properties of Sales or Lettings', '', 'string','S'],
              "mobile": ['Applicant mobile', '', 'string'],
							"address": ['Applicant address.', true, 'object',null,{ town: 'string',
								flatNumber: 'string',
								street: 'string',
								postcode: 'string',
								county: 'string',
								buildingNumber: 'string',
								latitude: 'number',
								longitude: 'number' }],
              "type": ['Looking for properties of type house or flat.', '', 'string'],
              "budget": ['Looking for properties with the given budget.', '', 'number'],
              "bedrooms": ['Looking for properties with the given bedrooms.', '', 'number'],
              "bathrooms": ['Looking for properties with the given bathrooms.', '', 'number'],
              "livingrooms": ['Looking for properties with the given livingrooms.', '', 'number'],
              "source": ['Source of the information', '', 'string'],
            },'APPLICANT-ADDED'],
            EDIT: ['Edit Applicant', 'Applicant Edited',{
              "applicantId": "Your-ID",
              "agentId": "Your_Agent_ID",
              "email": "userhas@email.com",
              "fullName": "Mr John Doe",
              "channel": "S",
              "mobile": "+44 7700 900694",
							"address":
							 { town: 'Hayes',
								 flatNumber: '1',
								 street: 'Bath Road',
								 postcode: 'UB3 5BP',
								 county: 'Greater London',
								 buildingNumber: 'A4',
								 latitude: 51.4815121,
								 longitude: -0.4365430999999944 },
							"type": "flat",
              "budget": 100000,
              "bedrooms": 2,
              "bathrooms": 2,
              "livingrooms": 1,
              "source": "zoopla",
            },{
              "applicantId": ['Applicant ID', true, 'string'],
              "agentId": ['Agent ID', true, 'string'],
              "email": ['Applicant email', true, 'string'],
              "fullName": ['Applicant full name', '', 'string'],
              "channel": ['Looking for properties of Sales or Lettings', '', 'string','S'],
              "mobile": ['Applicant mobile', '', 'string'],
							"address": ['Applicant address.', true, 'object',null,{ town: 'string',
								flatNumber: 'string',
								street: 'string',
								postcode: 'string',
								county: 'string',
								buildingNumber: 'string',
								latitude: 'number',
								longitude: 'number' }],
              "type": ['Looking for properties of type house or flat.', '', 'string'],
              "budget": ['Looking for properties with the given budget.', '', 'number'],
              "bedrooms": ['Looking for properties with the given bedrooms.', '', 'number'],
              "bathrooms": ['Looking for properties with the given bathrooms.', '', 'number'],
              "livingrooms": ['Looking for properties with the given livingrooms.', '', 'number'],
              "source": ['Source of the information', '', 'string'],
            },'APPLICANT-UPDATED'],
            DELETE: ['Delete Applicant', 'Applicant Deleted',{
              "applicantId": "Your-ID",
              "agentId": "Your_Agent_ID"
            },{
              "applicantId": ['Applicant ID', '', 'string'],
              "agentId": ['Agent ID', '', 'string']
            },'APPLICANT-DELETED']
          }
        },
        PROPERTY: {
          LABEL: 'Property',
          CONDITIONS: {
            ADD: {
              "status": "single"
            },
            EDIT: {
              "status": "fromto"
            },
            DELETE: {
            },
          },
          METHODS: {
            ADD: ['Add Property','Property Added',{
								propertyId: 'Your-ID',
                agentId: 'Your_Agent_ID',
                longDescription: 'Some long description',
                shortDescription: 'Short description',
                furnishingStatus: null,
                channel: 'S',
                type: 'terrace',
                features: [ '2 bedrooms', 'Flat', 'Based in Hayes' ],
                price: 102000,
                priceTerms: 'asking-price-of',
                epc: 'https://yoursite.com/files/your_sample.pdf',
                share: false,
                epcLetter: 'b',
                images: [ 'https://yoursite.com/images/1551974234692_sample.jpg' ],
                address:
                 { town: 'Hayes',
                   flatNumber: '1',
                   street: 'Bath Road',
                   postcode: 'UB3 5BP',
                   county: 'Greater London',
                   buildingNumber: 'A4',
                   latitude: 51.4815121,
                   longitude: -0.4365430999999944 },
                brochure: 'https://yoursite.com/files/your_sample.pdf',
                floorplans: ['https://yoursite.com/files/your_sample.pdf'],
                rentFrequency: 'PCM',
                bedrooms: 3,
                bathrooms: 2,
                livingrooms: 1,
                status: 'for-sale'
              },
              {
                "propertyId": ['Property ID', true, 'string'],
                "agentId": ['Agent ID', true, 'string'],
                "longDescription": ['Long description about the Property', '', 'string'],
                "shortDescription": ['Short description about the Property', '', 'string'],
                "furnishingStatus": ['The status of property furniture.', '', 'string',null,["furnished","unfurnished","part-furnished"]],
                "channel": ['If property is Sales or Lettings.', '', 'string',null,["L","S"]],
                "type": ['The property type.', '', 'string'],
                "features": ['The property features.', '', 'array',null,["['has barbecue']"]],
                "price": ['The price of the property.', '', 'number'],
                "priceTerms": ['The terms of the pricing.', '', 'string',null,["asking-price-of","poa","offers-in-excess-of","fixed-price","guide-price"]],
                "epc": ['Digitalized EPC.', '', 'string',null,["https://yoururl.com/file.pdf"]],
                "epcLetter": ['EPC letter', '', 'string',null,["a","b","c","d","e","f","g"]],
                "share": ['If the property is a share.', '', 'boolean',null,["true","false"]],
                "images": ['Images for the property.', '', 'array',null,["['https://yoururl.com/img1.jpg','https://yoururl.com/img2.jpg']"]],
                "address": ['The address of the property.', true, 'object',null,{ town: 'string',
                  flatNumber: 'string',
                  street: 'string',
                  postcode: 'string',
                  county: 'string',
                  buildingNumber: 'string',
                  latitude: 'number',
                  longitude: 'number' }],
                "brochure": ['The brochure of the property.', '', 'string',null,["https://yoururl.com/file.pdf"]],
                "floorplans": ['The floorplans of the property.', '', 'array',null,["['https://yoururl.com/file.jpg','https://yoururl.com/file.pdf']"]],
                "rentFrequency": ['The frequency of the rent, this depends on the channel paremeter: "L"', '', 'string',null,["PCM","PW"]],
                "bedrooms": ['Amount of bedrooms property has.', '', 'number'],
                "bathrooms": ['Amount of bathrooms property has.', '', 'number'],
                "livingrooms": ['Amount of livingrooms property has.', '', 'number'],
                "status": ['The current status of the property.', '', 'string',null,["to-let","under-offer","for-sale","appraisal","let"]],
              }
            ,'PROPERTY-ADDED'],
            EDIT: ['Edit Property','Property Edited', {
								propertyId: 'Your-ID',
                agentId: 'Your_Agent_ID',
                longDescription: 'Some long description',
                shortDescription: 'Short description',
                furnishingStatus: null,
                channel: 'S',
                type: 'terrace',
                features: [ '2 bedrooms', 'Flat', 'Based in Hayes' ],
                price: 102000,
                priceTerms: 'asking-price-of',
                epc: 'https://yoursite.com/files/your_sample.pdf',
                share: false,
                epcLetter: 'b',
                images: [ 'https://yoursite.com/images/1551974234692_sample.jpg' ],
                address:
                 { town: 'Hayes',
                   flatNumber: '1',
                   street: 'Bath Road',
                   postcode: 'UB3 5BP',
                   county: 'Greater London',
                   buildingNumber: 'A4',
                   latitude: 51.4815121,
                   longitude: -0.4365430999999944 },
                brochure: 'https://yoursite.com/files/your_sample.pdf',
                floorplans: ['https://yoursite.com/files/your_sample.pdf'],
                rentFrequency: 'PCM',
                bedrooms: 3,
                bathrooms: 2,
                livingrooms: 1,
                status: 'for-sale'
              },
              {
                "propertyId": ['Property ID', true, 'string'],
                "agentId": ['Agent ID', true, 'string'],
                "longDescription": ['Long description about the Property', '', 'string'],
                "shortDescription": ['Short description about the Property', '', 'string'],
                "furnishingStatus": ['The status of property furniture.', '', 'string',null,["furnished","unfurnished","part-furnished"]],
                "channel": ['If property is Sales or Lettings.', '', 'string',null,["L","S"]],
                "type": ['The property type.', '', 'string'],
                "features": ['The property features.', '', 'array',null,["['has barbecue']"]],
                "price": ['The price of the property.', '', 'number'],
                "priceTerms": ['The terms of the pricing.', '', 'string',null,["asking-price-of","poa","offers-in-excess-of","fixed-price","guide-price"]],
                "epc": ['Digitalized EPC.', '', 'string',null,["https://yoururl.com/file.pdf"]],
                "epcLetter": ['EPC letter', '', 'string',null,["a","b","c","d","e","f","g"]],
                "share": ['If the property is a share.', '', 'boolean',null,["true","false"]],
                "images": ['Images for the property.', '', 'array',null,["['https://yoururl.com/img1.jpg','https://yoururl.com/img2.jpg']"]],
                "address": ['The address of the property.', true, 'object',null,{ town: 'string',
                  flatNumber: 'string',
                  street: 'string',
                  postcode: 'string',
                  county: 'string',
                  buildingNumber: 'string',
                  latitude: 'number',
                  longitude: 'number' }],
                "brochure": ['The brochure of the property.', '', 'string',null,["https://yoururl.com/file.pdf"]],
                "floorplans": ['The floorplans of the property.', '', 'array',null,["['https://yoururl.com/file.jpg','https://yoururl.com/file.pdf']"]],
                "rentFrequency": ['The frequency of the rent, this depends on the channel paremeter: "L"', '', 'string',null,["PCM","PW"]],
                "bedrooms": ['Amount of bedrooms property has.', '', 'number'],
                "bathrooms": ['Amount of bathrooms property has.', '', 'number'],
                "livingrooms": ['Amount of livingrooms property has.', '', 'number'],
                "status": ['The current status of the property.', '', 'string',null,["to-let","under-offer","for-sale","appraisal","let"]],
              },'PROPERTY-UPDATED'],
            DELETE: ['Delete Property','Property Deleted', {
              propertyId: 'Your-ID',
              agentId: 'Your_Agent_ID'
            },
            {
              "applicantId": ['Property ID', '', 'string'],
              "agentId": ['Agent ID', '', 'string']
            },'PROPERTY-DELETED']
          }
        }
      },
      webhook: '',
      editing: false,
      isLoading: false,
      isCopied: false,
      testedSent: 0,
      showAllHelp: false,
      mode: null,
			conds: {},
      action: {
        actionId: 0,
        requestMethod: 'POST',
        requestUrl: '',
        type: '',
        action: '',
        method: '',
        params: {}
      }
    };
  },
  async created() {
    this.isLoading = true;
    const authData = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/auth',
      method: 'GET',
    });
    this.isLoading = false;
    if (this.$route.params.id) {
      this.action.actionId = this.$route.params.id;
      this.action = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/actions',
        method: 'POST',
        body: {
          do: 'get',
          action: this.action
        }
      });
      this.editing = true;
      this.mode = this.action.type;
      this.webhook = `${this.urlStage}${this.action.actionId}`;
      this.conds = this.action.conditions;
			this.methodPicked();
    }

  },
  watch: {
    mode: function (val) {
      this.action.type = val;
    },
    action: {
      handler(val){
        if (this.ACTIONS[val.action] && this.ACTIONS[val.action].METHODS[val.method]) {
					if (this.mode == this.MODES.RECEIVE) {
						this.sourcecode = JSON.stringify(this.ACTIONS[val.action].METHODS[val.method][2], null, 2).replace(/Your\-/g,'Our-');
					} else {
						this.sourcecode = JSON.stringify(this.ACTIONS[val.action].METHODS[val.method][2], null, 2);
					}
          this.sourcecodeSchema = this.ACTIONS[val.action].METHODS[val.method][3];
        } else {
          this.sourcecode = '';
          this.sourcecodeSchema = '';
        }
      },
      deep: true
    }
  },
  computed: {
    urlStage() {
      if (['production','live'].indexOf(process.env.NODE_ENV) !== -1) {
        return "https://webhooks.bestagent.online/";
      } else if (['stg','staging'].indexOf(process.env.NODE_ENV) !== -1) {
        return "https://stg-webhooks.bestagent.online/";
      } else {
        return "https://dev-webhooks.bestagent.online/";
      }
    },
    typesList() {
      return Object.keys(this.ACTIONS).map(action => {
        return {
          id: action,
          label: this.ACTIONS[action].LABEL,
          disabled: this.ACTIONS[action].DISABLED
        }
      }).sort((a,b) => {
        return a.label >= b.label
      });
    },
    methodsList() {
      if(this.action.action && this.ACTIONS[this.action.action]) {
        return Object.keys(this.ACTIONS[this.action.action].METHODS).map(method => {
          if (this.ACTIONS[this.action.action].METHODS[method][5]) { // disabled
            return {
              id: method,
              disabled: true,
              label: this.mode == this.MODES.RECEIVE ? this.ACTIONS[this.action.action].METHODS[method][1] : this.ACTIONS[this.action.action].METHODS[method][0]
            }
          } else {
            return {
              id: method,
              label: this.mode == this.MODES.RECEIVE ? this.ACTIONS[this.action.action].METHODS[method][1] : this.ACTIONS[this.action.action].METHODS[method][0]
            }
          }
        });
      } else {
        return [];
      }
    }
  },
  methods: {
		async methodPicked() {
			const that = this;
			this.conds = {};
			if (this.ACTIONS[this.action.action] && this.ACTIONS[this.action.action].CONDITIONS && this.ACTIONS[this.action.action].CONDITIONS[this.action.method]) {
				const filters = this.ACTIONS[this.action.action].CONDITIONS[this.action.method];

				await Promise.all(Object.keys(filters).map(f => {
					const inputtype = filters[f];
					let fields = [];
					if (
						this.ACTIONS[this.action.action].METHODS[this.action.method]
						&& this.ACTIONS[this.action.action].METHODS[this.action.method][3]
						&& this.ACTIONS[this.action.action].METHODS[this.action.method][3][f]
						&& this.ACTIONS[this.action.action].METHODS[this.action.method][3][f][4]
						&& this.ACTIONS[this.action.action].METHODS[this.action.method][3][f][4].length
					) {
						fields = this.ACTIONS[this.action.action].METHODS[this.action.method][3][f][4];
					}
					that.conds[f] = {};
					that.conds[f].value = null;
					that.conds[f].type = '==';
					that.conds[f].values = fields;
					that.conds[f].inputtype = inputtype;
				}));

			}
		},
    async generateWebhook() {
      this.isLoading = true;
      let action;
      if (this.action.actionId) {
        action = await api({
          endpoint: `${process.env.VUE_APP_API}/suppliers`,
          path: '/actions',
          method: 'POST',
          body: {
            do: 'regen',
            action: this.action
          }
        });
      } else {
        action = await api({
          endpoint: `${process.env.VUE_APP_API}/suppliers`,
          path: '/actions',
          method: 'POST',
          body: {
            do: 'save',
            action: this.action
          }
        });
      }
      if (action.actionId) {
        this.action.actionId = action.actionId;
        this.webhook = `${this.urlStage}${action.actionId}`;
        this.$router.push(`/actions/${action.actionId}`);
      }
      this.isLoading = false;

    },
    async del() {
      this.isLoading = true;
      const del = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/actions',
        method: 'POST',
        body: {
          do: 'del',
          action: this.action
        }
      });
      this.isLoading = false;
      this.$router.push('/');
    },
    async testedSend() {
      const that = this;
      this.isLoading = true;
      setTimeout(async function() {
        that.action.conditions = that.conds;
        const checkRequest = await api({
          endpoint: `${process.env.VUE_APP_API}/suppliers`,
          path: '/actions',
          method: 'POST',
          body: {
            do: 'tested',
            action: that.action
          }
        });
        if (!checkRequest && that.testedSent < 3) {
          that.isLoading = false;
          await that.testedSend();
        } else {
          if (checkRequest) {
            that.testedSent = 0;
            that.isLoading = false;
            that.$dialog.alert({
              title: 'Action confirmed!',
              message: `Your request was completed, action is now valid.`,
              type: 'is-success',
              confirmText: 'Okay!',
              hasIcon: true,
              icon: 'check-circle',
              iconPack: 'fa',
              onConfirm: () => {that.goToDashboard()},
            });
          } else {
            that.testedSent = 0;
            that.isLoading = false;
            that.$dialog.alert({
              title: 'Timeout!',
              message: `Your test took too much time, please try again.`,
              type: 'is-error',
              confirmText: 'Okay!',
              hasIcon: true,
              icon: 'check-circle',
              iconPack: 'fa'
            });
          }
        }
        that.testedSent+=1;
      },5000);
    },
    async testAction() {

      const test = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/actions',
        method: 'POST',
        body: {
          do: 'test',
          action: this.action
        }
      });
      return test;
    },
		goToDashboard(actionId) {
			const that = this;
			if (actionId && actionId != '' && actionId != this.action.actionId)
        this.$router.push(`/actions/${actionId}`);

			setTimeout(function(){
				that.$router.push('/');
			},500);
		},
    goToSaved(actionId) {
      if (actionId && actionId != '' && actionId != this.action.actionId)
        this.$router.push(`/actions/${actionId}`);
    },
    async save() {
      const that = this;
      this.isLoading = true;
      if (this.action.type == 2) {
        this.action.conditions = this.conds;
        this.action.baEvent = this.ACTIONS[this.action.action].METHODS[this.action.method][4];
      };

      const action = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/actions',
        method: 'POST',
        body: {
          do: 'save',
          action: this.action
        }
      });

      if (action && action.actionId) {
        this.webhook = `${this.urlStage}${action.actionId}`;
        this.action = action;
      }

      if (action) {
        const test = await this.testAction();
        if (this.action.type == 2) {
          if (test.statusCode && test.statusCode == 200) {
            this.$dialog.alert({
              title: 'Sample sent!',
              message: `Your app received information from BestAgent and returned a valid response:<br><br><span style="background-color:#e5e5e5;border:1px solid #a4a4a4;padding:5px;border-radius: 5px;">${JSON.stringify(test.response)}</span>`,
              type: 'is-success',
              confirmText: 'Okay!',
              hasIcon: true,
              icon: 'check-circle',
              iconPack: 'fa',
              onConfirm: () => {that.goToDashboard((action && action.actionId) ? action.actionId : '')},
            });
          } else {
            that.$dialog.alert({
              title: 'Invalid request!',
              message: `We sent a request to your end, and got invalid return:<br>Status Code: ${test.statusCode}<br>Response: ${test.response.replace(/\\n/ig,"<br>")}`,
              type: 'is-error',
              confirmText: 'Okay!',
              hasIcon: true,
              icon: 'check-circle',
              iconPack: 'fa',
              onConfirm: () => {that.goToSaved((action && action.actionId) ? action.actionId : '')},
            });
          }

        } else {
          this.$dialog.alert({
            title: 'Waiting for your request!',
            message: `Waiting for your request.<br>Send us a Trigger of that data to your webhook.<br><input class="input" type="text" value="${this.webhook}" readonly>`,
            type: 'is-warning',
            confirmText: 'Sent!',
            hasIcon: true,
            icon: 'clock',
            iconPack: 'fa',
            onConfirm: () => {that.testedSend()},
          });
        }
      }
      this.isLoading = false;
    },
    copyText() {
        var range = document.createRange();
        range.selectNode(document.getElementById("payload"));
        window.getSelection().removeAllRanges(); // clear current selection
        window.getSelection().addRange(range); // to select text
        document.execCommand("copy");
        window.getSelection().removeAllRanges();// to deselect
        this.isCopied = true;
        var that = this;
        setTimeout(function() {
            that.isCopied = false;
        }, 1500);
    },
  },
};
</script>
<style>
.select select option.disabled {
  background-color: #f6f6f6;
  color: #c5c5c5;

}
</style>
